import { formatPrice as currencyFormatterFormatPrice } from "@asosteam/asos-web-currency-formatter";
import webContextProvider from "../../../providers/webContextProvider";

const formatPrice = value => {
  const { browseLanguage, browseCurrency } = webContextProvider();

  return currencyFormatterFormatPrice(value, browseLanguage, browseCurrency);
};

export default formatPrice;
